import { render, staticRenderFns } from "./cnreport_main.vue?vue&type=template&id=37e60748&scoped=true"
import script from "./cnreport_main.vue?vue&type=script&lang=js"
export * from "./cnreport_main.vue?vue&type=script&lang=js"
import style0 from "./cnreport_main.vue?vue&type=style&index=0&id=37e60748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e60748",
  null
  
)

export default component.exports